// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type QrScan_SaveCheckoutConfigMutationVariables = Types.Exact<{
  input: Types.SaveCheckoutConfigInput;
}>;


export type QrScan_SaveCheckoutConfigMutation = { __typename?: 'Mutation', saveCheckoutConfig: { __typename?: 'SaveCheckoutConfigResult', checkoutConfig: { __typename?: 'CheckoutConfig', id: string } } };


export const QrScan_SaveCheckoutConfigDocument = gql`
    mutation QrScan_SaveCheckoutConfig($input: SaveCheckoutConfigInput!) {
  saveCheckoutConfig(input: $input) {
    checkoutConfig {
      id
    }
  }
}
    `;
export type QrScan_SaveCheckoutConfigMutationFn = Apollo.MutationFunction<QrScan_SaveCheckoutConfigMutation, QrScan_SaveCheckoutConfigMutationVariables>;

/**
 * __useQrScan_SaveCheckoutConfigMutation__
 *
 * To run a mutation, you first call `useQrScan_SaveCheckoutConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQrScan_SaveCheckoutConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [qrScanSaveCheckoutConfigMutation, { data, loading, error }] = useQrScan_SaveCheckoutConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQrScan_SaveCheckoutConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QrScan_SaveCheckoutConfigMutation, QrScan_SaveCheckoutConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QrScan_SaveCheckoutConfigMutation, QrScan_SaveCheckoutConfigMutationVariables>(QrScan_SaveCheckoutConfigDocument, options);
      }
export type QrScan_SaveCheckoutConfigMutationHookResult = ReturnType<typeof useQrScan_SaveCheckoutConfigMutation>;
export type QrScan_SaveCheckoutConfigMutationResult = Apollo.MutationResult<QrScan_SaveCheckoutConfigMutation>;
export type QrScan_SaveCheckoutConfigMutationOptions = Apollo.BaseMutationOptions<QrScan_SaveCheckoutConfigMutation, QrScan_SaveCheckoutConfigMutationVariables>;